'use strict';

module.exports = function (marty) {
  marty.autoDispatch = require('./autoDispatch');
  marty.ActionCreators = require('./actionCreators');
  marty.createActionCreators = require('./createActionCreatorsClass');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/action-creators/index.js
 ** module id = 539
 ** module chunks = 0
 **/